import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@chakra-ui/react';
import Swal from 'sweetalert2';
import { useMap } from 'react-leaflet';
import { POSITION_CLASSES } from '../../utils';
import { geolocation as geoConfig } from '../../app/config';

const showWarning = (message) => Swal.fire({
  text: message || 'Please enable location services',
  backdrop: false,
  showConfirmButton: false,
  showCancelButton: true,
  cancelButtonText: 'OK',
  cancelButtonColor: 'var(--color-dark-gray)',
});

const Geolocator = ({ position, zoomTo }) => {
  const [ loading, setLoading ] = useState(false);

  const map = useMap();

  const handleRepositionRequest = (event) => {
    event.preventDefault();

    if (!navigator.geolocation) {
      showWarning('Geolocation is not supported by your browser');
    } else {
      setLoading(true);
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        map.flyTo([ coords.latitude, coords.longitude ], zoomTo);
        setLoading(false);
      }, () => {
        setLoading(false);
        showWarning('Please enable location services');
      }, geoConfig);
    }
  };

  return (
    <div id="geolocator" className={POSITION_CLASSES[position]}>
      <div className="leaflet-control">
        <IconButton
          onClick={handleRepositionRequest}
          isRound
          aria-label="Geolocate"
          bg="white"
          border="1px solid rgba(0, 0, 0, 0.08)"
          color={loading ? 'brand.blue.500' : 'brand.red.500'}
          icon={(
            <FontAwesomeIcon
              icon={[ 'fas', 'location-arrow' ]}
              spin={loading}
            />
          )}
        />
      </div>
    </div>
  );
};

export default Geolocator;
